var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 12,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.788 10.0665C10.5887 9.86716 10.2655 9.86716 10.0662 10.0665C9.86683 10.2658 9.86683 10.589 10.0662 10.7883L13.2782 14.0003L10.0662 17.2123C9.86683 17.4117 9.86683 17.7348 10.0662 17.9342C10.2655 18.1335 10.5887 18.1335 10.788 17.9342L14 14.7222L17.212 17.9341C17.4113 18.1334 17.7345 18.1334 17.9338 17.9341C18.1332 17.7348 18.1332 17.4116 17.9338 17.2123L14.7219 14.0003L17.9338 10.7884C18.1332 10.5891 18.1332 10.2659 17.9338 10.0666C17.7345 9.86724 17.4113 9.86724 17.212 10.0666L14 13.2785L10.788 10.0665Z",
    fill: "white",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail);
export default __webpack_public_path__ + "static/media/Fail.79dbcbdf8ae2c5581411da670c725298.svg";
export { ForwardRef as ReactComponent };